import { DashboardApiService } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationService } from '@shared';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as DashboardActions from './dashboard.actions';

@Injectable()
export class DashboardEffects {
  private actions$ = inject(Actions);
  private dashboardApi = inject(DashboardApiService);
  private notification = inject(NotificationService);

  loadOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadDashboardOverview),
      switchMap(() =>
        this.dashboardApi.getOverview().pipe(
          map((overview) => DashboardActions.loadDashboardOverviewSuccess({ overview })),
          catchError((error: any) => {
            this.notification.error('admin.notifications.load_dashboard_error');
            return of(DashboardActions.loadDashboardOverviewFailure({ error: error.message || 'Failed to load dashboard' }));
          }),
        ),
      ),
    ),
  );

  loadUserStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadUserStats),
      switchMap(() =>
        this.dashboardApi.getUserStats().pipe(
          map((stats) => DashboardActions.loadUserStatsSuccess({ stats: stats.byRole || [] })),
          catchError((error: any) => {
            this.notification.error('admin.notifications.load_dashboard_error');
            return of(DashboardActions.loadUserStatsFailure({ error: error.message || 'Failed to load user stats' }));
          }),
        ),
      ),
    ),
  );

  loadEventStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadEventStats),
      switchMap(() =>
        this.dashboardApi.getEventStats().pipe(
          map((stats) => DashboardActions.loadEventStatsSuccess({ stats })),
          catchError((error: any) => {
            this.notification.error('admin.notifications.load_dashboard_error');
            return of(DashboardActions.loadEventStatsFailure({ error: error.message || 'Failed to load event stats' }));
          }),
        ),
      ),
    ),
  );

  loadVolunteerStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DashboardActions.loadVolunteerStats),
      switchMap(() =>
        this.dashboardApi.getVolunteerStats().pipe(
          map((stats) => DashboardActions.loadVolunteerStatsSuccess({ stats })),
          catchError((error: any) => {
            this.notification.error('admin.notifications.load_dashboard_error');
            return of(DashboardActions.loadVolunteerStatsFailure({ error: error.message || 'Failed to load volunteer stats' }));
          }),
        ),
      ),
    ),
  );
}
